<ng-container *ngIf="integrations$ | async"></ng-container>
<div
  class="wizard-integrations-list-spinner-container"
  *ngIf="isLoading; else default"
>
  <i style="font-size: 30px" class="fas fa-spinner fa-spin"></i>
</div>

<ng-template #default>
  <ng-container *ngIf="integrations?.length">
    <h5 class="wizard-heading-1">
      {{ "existing_integrations" | translation }}
    </h5>
    <div class="wizard-integrations-list">
      <app-wizard-integration-list-item
        *ngFor="let integration of integrations; let i = index"
        [integration]="integration"
        [index]="i"
      ></app-wizard-integration-list-item>
    </div>
  </ng-container>
</ng-template>
